// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"fd986f47","279":"783c1da6","384":"4c4145b7","402":"0efb9298","513":"c8f66999"}[chunkId] + ".chunk.css";
};